"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    disabled: false,
    multiline: false,
    isAnswered: false,
    isSafari: false,
    isAutoFilledActive: false,
    rows: 6,
    onChange: function () {
        // action
    },
    onClick: function () {
        // action
    },
    onBlur: function () {
        // action
    },
    size: 'medium',
    label: '',
    type: 'text',
    value: '',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map